import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

interface IAppStore {
  appLoader: boolean;
}

const appStore = (set: any) => ({
  appLoader: false,
  setLoader: (loader: boolean) =>
    set((state: IAppStore) => ({
      ...state,
      appLoader: loader,
    })),
  isSubmitModalVisible: false,
  setIsSubmitModalVisible: (isVisible: boolean) =>
    set((state: IAppStore) => ({
      ...state,
      isSubmitModalVisible: isVisible,
    })),
});

const useAppStore = create(
  devtools(
    persist(appStore, {
      name: "appStore",
    })
  )
);

export default useAppStore;
